/**
 * Anzeige-Version im Footer + Login-Brand-Panel.
 *
 * <p>Wird beim Build aus der Env-Variable {@code VITE_APP_VERSION} gelesen
 * (Vite-Konvention: nur {@code VITE_*}-Praefix landet im Client-Bundle).
 * Quelle:
 * <ul>
 *   <li><b>Dev-Server</b> ({@code dev.partroom.de}): Jenkins setzt die Variable
 *       auf die aktuelle Maven-Version aus {@code backend/pom.xml}
 *       (z.B. {@code 2.0.0-SNAPSHOT}).</li>
 *   <li><b>Prod-Server</b> ({@code partroom.de}): Jenkins setzt sie auf den
 *       Git-Tag, der den Build ausgeloest hat (z.B. {@code v2.1.0}).</li>
 *   <li><b>Lokales {@code pnpm dev}</b>: Variable nicht gesetzt, Fallback
 *       {@code 'dev'}.</li>
 * </ul>
 *
 * <p>Die Env-Variable wird zur Build-Zeit in das gebundelte JS eingesetzt —
 * nichts wird zur Laufzeit von Server gefragt. Aenderung erfordert
 * Re-Build des Frontend-Containers.
 */
export const APP_VERSION: string =
  (import.meta.env.VITE_APP_VERSION as string | undefined)?.trim() || 'dev'
